import Vue from 'vue';

export default class WeatherService {
    public async weatherApi(lat, long) {
        return await Vue.axios
        .get('https://api.openweathermap.org/data/2.5/weather?lat='+lat+'&lon='+long+'&appid=3a7ba574499c240ffdee1bcefb992b3c')
        .then((response) => response);
    }

    public async forecastApi(lat, long) {
        return await Vue.axios
        .get('https://api.openweathermap.org/data/2.5/forecast?lat='+lat+'&lon='+long+'&appid=3a7ba574499c240ffdee1bcefb992b3c')
        .then((response) => response);
    }

    // public async getSunriseTime(lat, long){
    //     return await Vue.axios
    //     .get('https://api.sunrise-sunset.org/json?lat='+lat+'&lng='+long+'&formatted=0')
    //     .then((response) => response);
    // }
}